import { render, staticRenderFns } from "./TimeslotExceptions.vue?vue&type=template&id=201d7534&"
import script from "./TimeslotExceptions.vue?vue&type=script&lang=js&"
export * from "./TimeslotExceptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports